import { EmailClientsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/email-clients')({
  component: EmailClientsRoute,
});
